import Loadable from '../../components/loadable';

const PosReconciliation = Loadable({
  loader: () => import('../../pages/pos/reconcile'),
  type: 'block',
});

angular.module('gym').value('PosReconciliation', PosReconciliation);

const PosReconciliationListFiltersModal = Loadable({
  loader: () => import('../../pages/pos/reconcile/reconciliations_list_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('PosReconciliationListFiltersModal', PosReconciliationListFiltersModal);
